import React, { Component } from 'react';
import $ from 'jquery';

//import Partnerlayout from './Partnerlayout';
import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getVerticalUserCount, adminDashboard } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import { Chart, registerables } from 'chart.js';

const doughnutPieOptions = {
          responsive: true,
          animation: {
            animateScale: true,
            animateRotate: true
          }
        };    

class partnerStats extends Component {

    constructor(props) {
        super(props);
        this.state = {
          school_data: []
        };
    }

    componentDidMount() {

        let req = {
            url: 'school_data'
        };

        adminDashboard(JSON.stringify(req)).then(response => {
            if (response.status === 1) {
                this.setSchoolChart(response.result);
            }
        });

                   


    }




    render() {

        return (
            <React.Fragment>


              <AdminLayout>
                    
              <div class="row  mt-3">
              


              <div class="col-xl-4 d-flex grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Overall Partners Statistics</h4>
                      
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <canvas id="barChartVisitors"></canvas>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>

            <div class="row">
                    <div class="col-lg-3 text-center">
                          <label>Average of Data Completion</label>
                          <div id="circleProgress6" class="progressbar-js-circle rounded p-3"></div>
                    </div>
                    <div class="col-lg-9 text-center">
                           <label>Paid and Unpaid Partners</label>  
                    </div>
                  </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default partnerStats;


// WEBPACK FOOTER //
// ./src/components/bewise/partnerStats.jsx